/** Row padding shared by side-menu items and the side-menu account selectors. */
export const MOBILE_NAVBAR_ITEM_PADDING_CLASS_NAME = 'px-3 py-2.5'

export const MOBILE_NAVBAR_ITEM_CLASS_NAME = `text-text-primary focus-visible:focus-ring-primary transition-base transition-colors [&_svg]:shrink-0 [&_svg]:transition-base [&_svg]:transition-[color,rotate] flex min-w-0 w-full items-center gap-2 rounded-md ${MOBILE_NAVBAR_ITEM_PADDING_CLASS_NAME} text-base font-medium outline-none [&_svg]:size-5 [&_svg]:text-icon-primary`

/**
 * Hover-open delay of the navbar's popovers (profile, notifications). Matches Base UI's
 * `NavigationMenu` default so they open as fast as the menu items next to them.
 */
export const NAVBAR_HOVER_OPEN_DELAY = 50

export const MENU_POPUP_SECTION_CLASS_NAME = 'px-4 py-3'

export const MENU_POPUP_SEPARATOR_CLASS_NAME = 'mx-4 w-auto'

/**
 * Box metrics of one desktop navigation row — height, font and the gap that holds the chevron.
 * Shared with the loading placeholders so they occupy exactly the space the real rows will.
 */
export const DESKTOP_NAVBAR_ITEM_LAYOUT_CLASS_NAME =
  'flex h-8 shrink-0 items-center gap-[2px] rounded-md text-base font-medium whitespace-nowrap'

/** Horizontal padding of a dropdown row: the chevron sits closer to the edge than the label. */
export const DESKTOP_NAVBAR_DROPDOWN_PADDING_CLASS_NAME = 'pr-1 pl-2'

/**
 * Every dropdown arrow on the desktop navbar is `Icon/Icon-tertiary`: the chevron is an affordance,
 * not content, so it stays grey even where the row's own label is primary or active.
 */
export const DESKTOP_NAVBAR_CHEVRON_CLASS_NAME = 'text-icon-tertiary'

/**
 * Same colour applied from the trigger instead of the icon. Needed wherever the trigger's own
 * variants already paint nested SVGs (`menuItemVariants`, `LanguageSwitcher`): a descendant rule
 * outranks a class on the icon, and only the identical `[&_svg]:` modifier lets `twMerge` drop the
 * colour it replaces. Spelled out rather than interpolated so Tailwind finds it while scanning.
 */
export const DESKTOP_NAVBAR_CHEVRON_CHILD_CLASS_NAME = '[&_svg]:text-icon-tertiary'

/**
 * Surface of a navbar panel — a popup that holds sections and controls rather than menu items, so
 * `Popover` owns it and the menu styles of `@systemeio/components` do not apply. Keeps the chrome
 * those panels had while they were menus.
 */
export const NAVBAR_PANEL_CLASS_NAME =
  'flex max-h-(--available-height) flex-col overflow-y-auto rounded-md transition-base origin-(--transform-origin) transition-[opacity,transform] data-starting-style:-translate-y-px data-starting-style:opacity-0 data-ending-style:opacity-0 data-ending-style:duration-150 data-ending-style:ease-in'

/** Icon-only navbar control: the same 32px box a labelled row has, without its padding. */
export const NAVBAR_ICON_BUTTON_CLASS_NAME =
  'focus-visible:focus-ring-primary text-icon-primary transition-base hover:bg-bg-tertiary data-popup-open:bg-bg-tertiary relative flex size-8 items-center justify-center rounded-md transition-colors outline-none'
